<template>
  <v-navigation-drawer floating v-model='drawer' id="side_menu_style" class="sideMenu-color-sm-and-down" :mini-variant-width="80" :mini-variant="mini" :permanent="$vuetify.breakpoint.mdAndUp" clipped v-if="$store.state.user" app>
    <div class="d-flex flex-column justify-start" style="height:100%;"> 
      <div style="margin:24px 0 0 80px;height:140px;width:96px;flex-grow:0">
        <div style="padding-top:12%;height:25%;">
          {{ currentDay[0].name }}
        </div>
          <div style="position:relative;height:50%;">
            <span style="position:absolute;margin-left:-18px;width:100%;top:28%;font-size:1.8em;">{{ currentDayOfMonth }}</span>
            <img style="padding-top:4%;" src="@/assets/images/ic_white_cal.png">
          </div>
        <div style="height:25%;">
          {{ currentMonth[0].name.toUpperCase() }}
        </div>
      </div>
      <div style="flex-grow:0">
        <v-tooltip color="menuTooltip" right>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn v-on="tooltip" fab small color="contrast" depressed @click.stop="mini = !mini" class="hidden-sm-and-down">
              <v-icon color="primary" v-if="mini">mdi-menu</v-icon>
              <v-icon color="primary" v-if="!mini">mdi-backburger</v-icon>
            </v-btn>
          </template>
          <span v-if="mini"> Agrandir le menu </span>
          <span v-if="!mini"> Réduire le menu </span>
        </v-tooltip>
        <v-list v-if='this.$store.state.user.id !== 295' style="padding-left:14px;background-color:transparent;">
          <v-list-item  id="custom-v-list-item" style ="margin:7px 0px 7px 0px;" v-for='item in items' :key='item.title' @click="redirectTo(item.route)" :to='item.route' link :class="item.class">
            <v-list-item-icon class="v-list-item__icon-custom">
              <v-img :src="item.icon"></v-img>
            </v-list-item-icon>
            <v-list-item-content style="text-align:left;">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if='this.$store.state.user.id === 44 || this.$store.state.user.id === 46' id="custom-v-list-item" style ="margin:7px 0px 7px 0px;" to='account-creation' link class="btn-menu-dashboard">
            <v-list-item-icon class="v-list-item__icon-custom">
              <v-img :src="require('@/assets/images/ic_dashboard.png')"></v-img>
            </v-list-item-icon>
            <v-list-item-content style="text-align:left;">
              <v-list-item-title> Creation de compte </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list v-if='this.$store.state.user.id === 295' style="padding-left:14px;background-color:transparent;">
          <v-list-item  id="custom-v-list-item" style ="margin:7px 0px 7px 0px;" v-for='item in itemsCultura' :key='item.title' @click="redirectTo(item.route)" :to='item.route' link :class="item.class">
            <v-list-item-icon class="v-list-item__icon-custom">
              <v-img :src="item.icon"></v-img>
            </v-list-item-icon>
            <v-list-item-content style="text-align:left;">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
      <div style="position:relative;flex-grow:1;">
        <a style="position:absolute;left:100px;bottom:48px" href="https://allsan.fr/" target="blank">
          <img style="width: 136px; height: 64px;opacity:0.6" src="@/assets/images/powered_by_allsan2.png" id="logoPixabay">
        </a>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  data () {
    return {
      items: [
        { title: this.$i18n.t('sidemenu.item1'), icon: require('@/assets/images/ic_new-media.png'), route: 'new-media', class: 'btn-menu-new-media' },
        /* { title: this.$i18n.t('sidemenu.item2'), icon: require('@/assets/images/ic_dashboard.png'), route: 'dashboard', class: 'btn-menu-dashboard' }, */
        { title: this.$i18n.t('sidemenu.item3'), icon: require('@/assets/images/ic_content.png'), route: 'content', class: 'btn-menu-content' },
        /* { title: this.$i18n.t('sidemenu.item4'), icon: require('@/assets/images/ic_brand.png'), route: 'brand', class: 'btn-menu-brand' }, */
        { title: this.$i18n.t('sidemenu.item5'), icon: require('@/assets/images/ic_screens.png'), route: 'screens', class: 'btn-menu-screens' }
      ],
      itemsCultura: [
        { title: this.$i18n.t('sidemenu.item1'), icon: require('@/assets/images/ic_new-media.png'), route: 'new-media', class: 'btn-menu-new-media' },
        { title: this.$i18n.t('sidemenu.item3'), icon: require('@/assets/images/ic_content.png'), route: 'content', class: 'btn-menu-content' },
      ],
      months: [
        { id: 0, name: this.$i18n.t('global.months.0') },
        { id: 1, name: this.$i18n.t('global.months.1') },
        { id: 2, name: this.$i18n.t('global.months.2') },
        { id: 3, name: this.$i18n.t('global.months.3') },
        { id: 4, name: this.$i18n.t('global.months.4') },
        { id: 5, name: this.$i18n.t('global.months.5') },
        { id: 6, name: this.$i18n.t('global.months.6') },
        { id: 7, name: this.$i18n.t('global.months.7') },
        { id: 8, name: this.$i18n.t('global.months.8') },
        { id: 9, name: this.$i18n.t('global.months.9') },
        { id: 10, name: this.$i18n.t('global.months.10') },
        { id: 11, name: this.$i18n.t('global.months.11') }
      ],
      days: [
        { id: 0, name: this.$i18n.t('global.days.7') },
        { id: 1, name: this.$i18n.t('global.days.1') },
        { id: 2, name: this.$i18n.t('global.days.2') },
        { id: 3, name: this.$i18n.t('global.days.3') },
        { id: 4, name: this.$i18n.t('global.days.4') },
        { id: 5, name: this.$i18n.t('global.days.5') },
        { id: 6, name: this.$i18n.t('global.days.6') }
      ],
      drawer: null,
      mini: false,
      currentMonth: null,
      currentDay: null,
      currentDayOfMonth: null,
      currentRoute: ''
    }
  },
  async created () {

    this.drawer = this.$store.state.drawer ? this.$store.state.drawer : true
    var date = new Date()
    this.currentMonth = this.months.filter(element => {
      return element.id === date.getMonth()
    })
    this.currentDay = this.days.filter(element => {
      return element.id === date.getDay()
    })
    this.currentDayOfMonth = date.getDate()
  },
  methods: {
    redirectTo (route) {
      if (route === this.currentRoute) {
        window.location.reload(false)
        //window.location.href = sessionStorage.getItem('currentroute')
      }
      sessionStorage.setItem('currentroute', document.location.href)
      this.currentRoute = route
    }
  },
  watch: {
    drawer () {
      this.$store.dispatch('setIsDrawer', this.drawer)
    },
    '$store.state.drawer': function() {
      this.drawer = this.$store.state.drawer
    },
    mini () {
      console.log(this.mini)
    }
  }
}
</script>

<style scoped>

</style>
